import React, { useState } from 'react';
import './apiAuth';
import { getUsuarioActual, limpiarSesion } from './apiAuth';
import Login from './Login';
import { Header, Footer, styles as st } from './components/Layout';
import Usuarios from './components/Usuarios';
import Catalogos from './components/Catalogos';
import Clientes from './components/Clientes';
import Notificaciones from './components/Notificaciones';
import MiUsuario from './components/MiUsuario';

const MENUS_POR_ROL = {
  Administrador: ['Clientes', 'Notificaciones', 'Usuarios', 'Catálogos'],
  Broker: ['Usuario', 'Clientes', 'Notificaciones'],
  Inmobiliaria: ['Usuario', 'Clientes'],
};

function App() {
  const [usuarioActual, setUsuarioActual] = useState(() => getUsuarioActual());
  const [menu, setMenu] = useState('Clientes');
  const [clienteIdInicial, setClienteIdInicial] = useState(null);

  const menusVisibles = usuarioActual ? MENUS_POR_ROL[usuarioActual.tipo_usuario] || [] : [];

  const abrirClienteDesdeNotificacion = (clienteId) => {
    setClienteIdInicial(clienteId);
    setMenu('Clientes');
  };

  const onLogin = (usuario) => {
    setUsuarioActual(usuario);
    setMenu('Clientes');
  };

  const onLogout = () => {
    limpiarSesion();
    setUsuarioActual(null);
  };

  if (!usuarioActual) {
    return <Login onLogin={onLogin} />;
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#f3f4f6' }}>
      <Header usuarioActual={usuarioActual} menu={menu} setMenu={setMenu} menusVisibles={menusVisibles} onLogout={onLogout} />
      <div style={{ ...st.page, flex: 1, width: '100%' }}>
        {menu === 'Usuario' && <MiUsuario />}
        {menu === 'Usuarios' && <Usuarios />}
        {menu === 'Catálogos' && <Catalogos />}
        {menu === 'Clientes' && (
          <Clientes
            usuarioActual={usuarioActual}
            clienteIdInicial={clienteIdInicial}
            onClienteIdConsumido={() => setClienteIdInicial(null)}
          />
        )}
        {menu === 'Notificaciones' && <Notificaciones onAbrirCliente={abrirClienteDesdeNotificacion} />}
      </div>
      <Footer />
    </div>
  );
}

export default App;
